/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".notifyBadge[_ngcontent-%COMP%]{right:3px;top:7px;position:absolute}"];
export { styles as styles };
